"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _Event = _interopRequireDefault(require("MeetingsLib/models/Event"));

var _BookingLifecycle = _interopRequireDefault(require("MeetingsLib/models/BookingLifecycle"));

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _handleActions;

var eventInitialState = (0, _Event.default)();
var event = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_EVENT_DATE, function (state, action) {
  return state.set('dateString', action.date).set('dateTime', null);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_EVENT_DATE_TIME, function (state, action) {
  return state.set('dateTime', action.dateTime);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.BOOKING_TIME_CONFLICT, function (state) {
  return state.set('dateTime', null);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_EVENT_DURATION, function (state, action) {
  return state.set('duration', action.duration).set('dateTime', null);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var durations = action.payload.bookInfo.customParams.durations;
  var stateWithDuration = state.set('duration', durations.first());
  var formFields = action.payload.bookInfo.customParams.formFields;
  return stateWithDuration.set('formFields', formFields);
}), _handleActions), eventInitialState);
var postResponseInitialState = null;
var postResponse = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, ActionTypes.MEETING_CREATE_SUCCEEDED, function (state, action) {
  return action.payload;
}), postResponseInitialState);

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _BookingLifecycle.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return state.set('event', event(state.event, action)).set('postResponse', postResponse(state.postResponse, action));
};

exports.default = _default;
module.exports = exports.default;